import { useEffect, useState } from "react";
import { API_URL } from "@/lib/api";

/** Public website origin for static /media template assets shared with the frontend. */
export const WEBSITE_ORIGIN = (
  process.env.REACT_APP_WEBSITE_URL || "https://www.casmediasolutions.com"
).replace(/\/$/, "");

/** Template images that mirror CasMediaSolutions_Website/src/data/site.js defaults. */
export const SITE_STATIC_PATHS = {
  brandLogo: "/media/brand/logo-icon.png",
  favicon: "/media/brand/logo-icon.png",
  hero: "/media/hero/cas hero banner.jpg",
  footerLogo: "/media/brand/logo-icon.png",
};

export const SERVICE_STATIC_PATHS = {
  "advertising-and-branding": "/media/services/Advertising and Branding.png",
  "social-media-management": "/media/services/Social media manegement.png",
  "website-design-and-development": "/media/services/Website Design and development.PNG",
  "mobile-app-development": "/media/services/Mobile App Development.png",
  "game-development": "/media/services/Game Development.png",
  "animation-video-production": "/media/services/Animation video.png",
  "architecture-visualization": "/media/services/Architechture Visualization.PNG",
};

export function serviceStaticUrl(slug) {
  const path = SERVICE_STATIC_PATHS[slug];
  return path ? `${WEBSITE_ORIGIN}${encodeURI(path)}` : "";
}

export function siteStaticUrl(key) {
  const path = SITE_STATIC_PATHS[key] || "";
  return path ? `${WEBSITE_ORIGIN}${encodeURI(path)}` : "";
}

/** Resolve relative site / API media paths for admin previews (same assets as www). */
export function resolveMediaUrl(src, fallback = "") {
  if (!src) return fallback || "";
  const value = String(src).trim();
  if (!value) return fallback || "";
  if (value.startsWith("//")) return `https:${value}`;
  if (/^https?:\/\//i.test(value)) return value;
  // Admin host has no /api proxy — always absolute against the API origin
  if (value.startsWith("/api/media/")) return `${API_URL}${value}`;
  if (value.includes("/api/media/public/")) {
    const path = value.slice(value.indexOf("/api/media/public/"));
    return `${API_URL}${path}`;
  }
  // Legacy broken favicon seed → shared brand logo template
  if (value === "/favicon.png" || value === "/favicon.ico") {
    return siteStaticUrl("favicon") || fallback || "";
  }
  if (value.startsWith("/media/") || value.startsWith("/")) {
    return `${WEBSITE_ORIGIN}${encodeURI(value)}`;
  }
  return value || fallback || "";
}

export function mediaDisplaySrc(src, slug) {
  const fallback = serviceStaticUrl(slug);
  return resolveMediaUrl(src, fallback) || fallback;
}

export function ImgWithFallback({ src, fallback, alt = "", className }) {
  const initial = resolveMediaUrl(src, fallback) || fallback || "";
  const [current, setCurrent] = useState(initial);

  useEffect(() => {
    setCurrent(resolveMediaUrl(src, fallback) || fallback || "");
  }, [src, fallback]);

  if (!current) return null;

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onError={() => {
        const fb = fallback || "";
        if (fb && current !== fb) setCurrent(fb);
      }}
    />
  );
}
